import { CurrencyCode } from "Infrastructure/Api/Api";

export const KNOWN_HARDWARE_MODELS = ["N92", "P300"];

// Mirrors CurrencyCodeExtensions.SupportedCurrencies on BE.
export const CURRENCY_OPTIONS: ReadonlyArray<CurrencyCode> = [
  CurrencyCode.CZK,
  CurrencyCode.EUR,
];
